import { ILendingResult } from './types';

/**
 * Messages back to the merchant's page (public/sdk.js turns them into its onSuccess, onIneligible and onClose
 * callbacks). They go only to the page that opened the SDK, never to '*'.
 */
let parentOrigin: string | null = null;

export const setParentOrigin = (origin: string) => {
  parentOrigin = origin;
};

const post = (message: string, payload: ILendingResult) => {
  if (!parentOrigin || window.parent === window) {
    return;
  }
  window.parent.postMessage({ message, payload }, parentOrigin);
};

/** The equity is paid. The merchant still waits for the application.funded webhook to release the product. */
export const notifySuccess = (payload: ILendingResult) => post('onLendingSuccess', payload);

export const notifyIneligible = (payload: ILendingResult) => post('onLendingIneligible', payload);

/** The customer closed the SDK; the merchant's page removes the frame. */
export const notifyClose = (payload: ILendingResult) => post('onLendingClose', payload);
